import { useState } from 'react'
import { Link } from 'react-router-dom'
import useAuthStore from '../store/auth-store'
import { UserDropdown } from './UserDropdown'
import { SignInModal } from './SignInModal'
import { CreateAccountModal } from './CreateAccountModal'

export function Navigation() {
  const [showSignInModal, setShowSignInModal] = useState(false)
  const [showCreateAccountModal, setShowCreateAccountModal] = useState(false)
  const { isAuthenticated, user, logout } = useAuthStore()

  const handleSwitchToCreateAccount = () => {
    setShowSignInModal(false)
    setShowCreateAccountModal(true)
  }

  const handleSwitchToSignIn = () => {
    setShowCreateAccountModal(false)
    setShowSignInModal(true)
  }

  const handleLogout = () => {
    logout()
    window.location.href = '/login'
  }

  return (
    <>
      <nav className="sticky top-0 z-50">
        {/* Top Dark Teal Bar — matches XD design */}
        <div className="bg-[#358ECD]">
          <div className="max-w-[1920px] mx-auto px-4 sm:px-6 lg:px-[26px] flex justify-end items-center gap-0">
            {isAuthenticated ? (
              <UserDropdown />
            ) : (
              <button onClick={() => setShowSignInModal(true)} className="text-white text-sm hover:text-blue-100 transition cursor-pointer bg-transparent border-none px-4 py-2.5">Sign In</button>
            )}

            {/* Messages — only for authenticated users */}
            {isAuthenticated && (
              <a href="#" className="flex items-center gap-1.5 px-4 py-2.5 text-white text-sm font-medium hover:bg-white/10 transition">
                <svg width="18" height="18" viewBox="0 0 24 24" fill="none">
                  <path d="M15 17H20L18.595 15.595C18.21 15.21 18 14.689 18 14.144V11C18 8.387 16.286 6.168 14 5.341V5C14 3.895 13.105 3 12 3C10.895 3 10 3.895 10 5V5.341C7.714 6.168 6 8.387 6 11V14.144C6 14.689 5.79 15.21 5.405 15.595L4 17H9M15 17V18C15 19.657 13.657 21 12 21C10.343 21 9 19.657 9 18V17M15 17H9" stroke="white" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                </svg>
                <span>Messages</span>
              </a>
            )}

            {/* Help Center */}
            <a href="#" className="flex items-center gap-1.5 px-4 py-2.5 text-white text-sm font-medium hover:bg-white/10 transition">
              <svg width="18" height="18" viewBox="0 0 24 24" fill="none">
                <circle cx="12" cy="12" r="9" stroke="white" strokeWidth="1.5"/>
                <path d="M12 17V16.5M12 13.5C12 13.5 14 12 14 10C14 8.895 13.105 8 12 8C10.895 8 10 8.895 10 10" stroke="white" strokeWidth="1.5" strokeLinecap="round"/>
              </svg>
              <span>Help Center</span>
            </a>

            {/* nexsens.com */}
            <a
              href="https://www.nexsens.com"
              target="_blank"
              rel="noopener noreferrer"
              className="text-sm px-5 py-2.5 bg-white font-medium text-[#4D4D4D] hover:bg-gray-100 transition self-stretch flex items-center border-l border-white/20"
            >
              nexsens.com
            </a>
          </div>
        </div>
      
      {/* Main Navigation */}
      <div className="bg-white border-b border-gray-200">
        <div className="max-w-[1920px] mx-auto px-4 sm:px-6 lg:px-[140px]">
           {!isAuthenticated && (
          <div className="flex justify-between items-end gap-2 py-2">
            {/* Logo */}
            <Link to="/" className="max-w-[25%] flex-[25%]">
              <img 
                src="/images/logo.png" 
                alt="WQData LIVE" 
                className="max-w-[100%]"
              />
            </Link>

            {/* Center Menu */}
            <div className="hidden md:flex items-end gap-[48px] max-w-[65%] flex-[65%] justify-end">
              <a href="#about" className="text-base font-bold text-[#4D4D4D] hover:text-blue-600 transition">About WQData LIVE</a>
              <a href="#features" className="text-base font-bold text-[#4D4D4D] hover:text-blue-600 transition">Features</a>
              <a href="#projects" className="text-base font-bold text-[#4D4D4D] hover:text-blue-600 transition">Demo</a>
              <a href="#plans" className="text-base font-bold text-[#4D4D4D] hover:text-blue-600 transition">Plans</a>
            </div>

            {/* Right side - Get Started Only */}
            <div className="flex items-end gap-4">
             
                <a href="/login" className="text-base font-bold transition text-[#358ECD]">
                  Get Started
                </a>
            </div>
          </div>
          )}
        </div>
      </div>
    </nav>

    <SignInModal 
      isOpen={showSignInModal} 
      onClose={() => setShowSignInModal(false)}
      onSwitchToCreateAccount={handleSwitchToCreateAccount}
    />
    <CreateAccountModal 
      isOpen={showCreateAccountModal}
      onClose={() => setShowCreateAccountModal(false)}
      onSwitchToSignIn={handleSwitchToSignIn}
    />
    </>
  )
}
